import { mapGetters } from 'vuex';
import Service from '../service-service';
import RegExp from '@/utils/regExp.js';
import HomeService from '@/views/home/service.js';
import LocationSelect from '../../share/location-select/index.vue';
export default {
  components: {
    LocationSelect
  },
  computed: {
    ...mapGetters([
      'isSignin',
      'userInfo',
      'refresh'
    ])
  },
  data: () => {
    return {
      ruleForm: {
        serviceType: '',
        cateList: [],
        mobile: '',
        idCard: '',
        name: '',
        address: '',
        tId: '66aaf784247b9fffdb5eba0b',
        pId: '',
        areaCode: '',
        category: '',
        area: '',
        landList: [],
        contractArea: 0,
        serviceArea: '',
        landCount: '',
        landActuality: null,
        username: '',
        merchant: '',
        source: 'spring_app',
        regionDisplay: '',
        detailDisplay: '',
        year: '',
        landActualityDisplay: ''
      },
      tId: '66aaf784247b9fffdb5eba0b',
      serviceList: [],
      submitStatus: '',
      yearList: [],
      landList: [],
      rules: {
        name: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { pattern: RegExp.idCard, message: '请输入正确的身份证号', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: RegExp.phone, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        landCount: [
          { required: true, message: '请输入地块数量', trigger: 'blur' }
        ],
        areaCode: [
          { required: true, message: '请选择地址', trigger: 'change' },
          { pattern: /^\d{12}$/, message: '请选择到村', trigger: 'change' }
        ],
        area: [
          { required: true, message: '请输入服务面积', trigger: 'blur' }
        ],
        category: [
          { required: true, message: '请选择作物类型', trigger: 'change' }
        ],
        pId: [
          { required: true, message: '请选择服务项目', trigger: 'change' }
        ],
        crop: [
          { required: true, message: '请选择作物类型', trigger: 'change' }
        ],
        username: [
          { required: true, message: '请输入联系人', trigger: 'change' }
        ]
      },
      areaData: {
        visible: false,
        index: 0,
        areaList: [],
        data: [],
        areaName: ''
      },
      detail: {},
      cropList: [{ value: '玉米', key: 'A0113' }, { value: '水稻', key: 'A0111' }, { value: '大豆', key: 'A0121' }, { value: '小麦', key: 'A0112' }, { value: '其他', key: 'else' }],
      activeType: ''
    };
  },
  created () {
    this.activeType = this.$route.query.type;
    if (this.activeType === '001') {
      Service.getServiceDetail({ id: this.$route.query.id }).then(res => {
        this.detail = res;
        this.ruleForm.category = res.category;
        this.ruleForm.pId = res._id;
        this.ruleForm.merchant = res.partnerId;
        this.ruleForm.crop = res.crop;
        if (res.items) {
          this.ruleForm.productItems = res.items.map(item => item._id);
        }
      });
      this.initYear();
    } else {
      const code = this.activeType.substring(0, 3);
      Service.getServiceList({ tId: '66aaf784247b9fffdb5eba0b', category: code }).then(res => {
        this.serviceList = res;
        if (this.activeType.length === 6) {
          this.ruleForm.pId = this.serviceList.find(item => item.category === this.activeType)._id;
        }
      });
      this.ruleForm.merchant = this.$route.query.partnerId;
    }
    this.getUserInfo();
  },
  methods: {
    getUserInfo () {
      HomeService.getUserBaseInfo().then(res => {
        this.ruleForm.username = res.data.legalName || res.data.name;
        this.ruleForm.idCard = res.data.legalIdCard || res.data.idCard;
        this.ruleForm.mobile = res.data.assignorMobile || res.data.mobile;
        this.getLandList();
      });
    },

    updatePid () {
      const target = this.serviceList.find(item => item._id === this.ruleForm.pId);
      this.ruleForm.category = target.category;
    },

    updateLandList () {
      const landList = this.landList.filter(item => this.ruleForm.landList.includes(item.landCode));
      this.ruleForm.contractArea = landList.reduce((totalPrice, item) => totalPrice + Number(item.area), 0);
      // this.ruleForm.area = this.ruleForm.landList.reduce(function (x, y) {
      //   return x.plus(y.area);
      // }, new Big(0)).toFixed(2);
    },

    initYear () {
      if (!this.ruleForm.year) {
        var year = new Date().getFullYear();
        const day = new Date(year + '-03-01');
        if (new Date().getTime() < day.getTime()) {
          this.ruleForm.year = year - 1;
        }
      }
      const today = new Date().getFullYear();
      for (var i = 0; i < 3; i++) {
        const year = today - i;
        this.yearList.push(year);
      }
    },
    getLandList () {
      Service.getLandList({ IDCard: this.ruleForm.idCard, realname: this.ruleForm.username }).then(res => {
        this.landList = res.lands;
      });
    },
    areaCodeChange (event) {
      this.ruleForm.areaCode = event.areaCode;
    },

    back () {
      this.$confirm('确定离开本页面？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.back();
      });
    },

    submit () {
      if (this.submitStatus === 'ongoing') {
        return;
      }
      if (this.activeType === '001') {
        if (!this.ruleForm.year) {
          this.$errorMessage('请选择订单年份');
          return;
        }
      }
      this.$refs.basicForm.validate((valid) => {
        if (valid) {
          this.submitStatus = 'ongoing';
          if (this.activeType === '001') {
            Service.checkTrustAreaCode({
              'productId': this.$route.query.id,
              'areaCode': this.ruleForm.areaCode
            }).then(res => {
              if (res.enable) {
                this.createOrder();
              } else {
                this.submitStatus = 'init';
                this.$errorMessage('你的地址不在托管服务区域范围内，请修改后提交');
              }
            });
          } else {
            this.createOrder();
          }
        }
      });
    },

    createOrder () {
      Service.applyService(this.ruleForm).then(() => {
        this.$alert('订单提交成功，请在个人中心进行订单查询', ' ', {
          confirmButtonText: '确定',
          callback: () => {
            this.$router.back();
          }
        });
      }, error => {
        this.$errorMessage(error.data.reason);
      }).finally(() => {
        this.submitStatus = '';
      });
    }
  }
};
